module.exports = __webpack_public_path__ + "static/Calibre-LightItalic-1222cf0d45062719e06c3d7d44937e8f.woff";